import styles from "../../../styles/MobileNumberContactUs.module.css";

// images
import ContactUsMobileNumberImg from "../../../assets/images/contact-us-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";
import ContactUsModalImage from "../../../assets/images/contact-us-modal-image.png";

// legion
import {
  Image,
  Flex,
  Select,
  Button,
  Text,
  Anchor,
  Textfield,
  Modal,
  Textarea,
} from "@legion-ui/core";

// hooks
import { useEmailAddressContactUs } from "../../../hooks/useEmailAddressContactUs";

export const EmailAddressContactUs = () => {
  const { showModal, state, handleForms, handleSubmit, handleBackToSignIn } =
    useEmailAddressContactUs();

  return (
    <Flex width="100%" height="100%">
      <Modal show={showModal} width="528px">
        <Image
          width="146px"
          src={ContactUsModalImage}
          alt="modal letter image"
          margin="auto"
        />

        <Text
          as="p"
          size="24px"
          color="tertiary900"
          margin="10px 0 8px 0"
          weight="700"
          style={{ textAlign: "center" }}
        >
          Message has been sent
        </Text>

        <Text
          as="p"
          color="tertiary500"
          margin="0 0 24px 0"
          style={{ textAlign: "center" }}
        >
          Thank you for contacting us and we will immediately respond to your
          message as fast as possible.
        </Text>

        <Button block center variant="solid" onClick={handleBackToSignIn}>
          Back to Sign In
        </Button>
      </Modal>

      <Flex
        alignX="center"
        alignY="start"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.contact__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Contact Us
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Have a problem, issue, feedback or concern? Contact us and our team
            will get back to you as soon as possible.
          </Text>

          <Textfield
            padding="0 0 24px 0"
            before="+62"
            label="Mobile Number"
            placeholder="85123456XXXXX"
            type="number"
            status={state.phoneNumberStatus}
            message={state.phoneNumberErrorMessage}
            onChange={handleForms("phoneNumber")}
          />

          <Select
            padding="0 0 24px 0"
            status={state.categoryStatus}
            message={state.categoryErrorMessage}
            onChange={handleForms("category")}
            placeholder="Select your specific category"
            defaultValue={[]}
            label="Category"
            options={[
              {
                label: "Forgot your mobile number",
                value: "forgot-mobile-number",
              },
              {
                label: "Have issue in receiving OTP code",
                value: "receiving-otp-issue",
              },
              {
                label: "Have a trouble while registering new account",
                value: "register-new-account-issue",
              },
            ]}
          />

          <Textarea
            padding="0 0 24px 0"
            label="Description"
            status={state.descriptionStatus}
            message={state.descriptionErrorMessage}
            placeholder="Type your detail problem, issue, feedback or concern"
            rows={3}
            style={{ maxWidth: "464px" }}
            onChange={handleForms("description")}
          />

          <Button margin="48px 0 24px 0" center onClick={handleSubmit}>
            Submit
          </Button>

          <Button
            variant="soft"
            margin="0 0 32px 0"
            center
            onClick={handleBackToSignIn}
          >
            Back to Sign In
          </Button>

          <div style={{ textAlign: "center" }}>
            <Text margin="0 0 40px 0" as="p" color="tertiary500">
              Don't have an account?{" "}
              <Anchor
                href="/register/mobile-number"
                weight="700"
                color="primary500"
              >
                Register
              </Anchor>
            </Text>
          </div>
        </Flex>
      </Flex>

      <Flex alignX="end" className={styles.contact__image} width={["", "50%"]}>
        <Image
          width="auto"
          height="100%"
          src={ContactUsMobileNumberImg}
          fit="cover"
          alt="contact us mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
